export default {
  scale(num, inMin, inMax, outMin, outMax) {
    if (inMax === inMin) {
      return 0
    }
    if (num < inMin) {
      return outMin
    }
    if (num > inMax) {
      return outMax
    }
    return ((num - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin
  },
  scaleImageData(imageData, scale) {
    let scaled = new ImageData(
      imageData.width * scale,
      imageData.height * scale
    )
    for (let row = 0; row < imageData.height; row++) {
      for (let col = 0; col < imageData.width; col++) {
        let sourcePixel = [
          imageData.data[(row * imageData.width + col) * 4 + 0],
          imageData.data[(row * imageData.width + col) * 4 + 1],
          imageData.data[(row * imageData.width + col) * 4 + 2],
          imageData.data[(row * imageData.width + col) * 4 + 3]
        ]
        for (let y = 0; y < scale; y++) {
          let destRow = row * scale + y
          for (let x = 0; x < scale; x++) {
            let destCol = col * scale + x
            for (let i = 0; i < 4; i++) {
              scaled.data[(destRow * scaled.width + destCol) * 4 + i] =
                sourcePixel[i]
            }
          }
        }
      }
    }
    return scaled
  },
  hexToRgb(hex) {
    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
    return result
      ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16)
        }
      : null
  },
  getGradient(colormap) {
    if (colormap === 'YlGnBu') {
      return [
        '#FFFFD9',
        '#FEFED7',
        '#FDFED5',
        '#FCFED4',
        '#FCFDD2',
        '#FBFDD1',
        '#FAFDCF',
        '#F9FDCD',
        '#F9FCCC',
        '#F8FCCA',
        '#F7FCC9',
        '#F7FBC7',
        '#F6FBC5',
        '#F5FBC4',
        '#F4FBC2',
        '#F4FAC1',
        '#F3FABF',
        '#F2FABD',
        '#F2F9BC',
        '#F1F9BA',
        '#F0F9B9',
        '#EFF9B7',
        '#EFF8B5',
        '#EEF8B4',
        '#EDF8B2',
        '#EDF8B1',
        '#EBF7B1',
        '#E9F6B1',
        '#E8F6B1',
        '#E6F5B1',
        '#E5F5B1',
        '#E3F4B1',
        '#E2F3B1',
        '#E0F3B1',
        '#DFF2B2',
        '#DDF2B2',
        '#DCF1B2',
        '#DAF0B2',
        '#D9F0B2',
        '#D7EFB2',
        '#D6EFB2',
        '#D4EEB2',
        '#D3EDB3',
        '#D1EDB3',
        '#D0ECB3',
        '#CEECB3',
        '#CDEBB3',
        '#CBEAB3',
        '#CAEAB3',
        '#C8E9B3',
        '#C7E9B4',
        '#C4E7B4',
        '#C1E6B4',
        '#BEE5B4',
        '#BBE4B5',
        '#B8E3B5',
        '#B5E2B5',
        '#B2E1B5',
        '#AFE0B6',
        '#ADDEB6',
        '#AADDB6',
        '#A7DCB7',
        '#A4DBB7',
        '#A1DAB7',
        '#9ED9B7',
        '#9BD8B8',
        '#98D7B8',
        '#96D5B8',
        '#93D4B9',
        '#90D3B9',
        '#8DD2B9',
        '#8AD1B9',
        '#87D0BA',
        '#84CFBA',
        '#81CEBA',
        '#7FCDBB',
        '#7CCCBB',
        '#7ACBBB',
        '#77CABC',
        '#75C9BC',
        '#72C8BC',
        '#70C7BD',
        '#6DC6BD',
        '#6BC5BD',
        '#68C4BE',
        '#66C3BE',
        '#63C2BE',
        '#61C1BF',
        '#5EC1BF',
        '#5CC0C0',
        '#59BFC0',
        '#57BEC0',
        '#54BDC1',
        '#52BCC1',
        '#4FBBC1',
        '#4DBAC2',
        '#4AB9C2',
        '#48B8C2',
        '#45B7C3',
        '#43B6C3',
        '#41B6C4',
        '#3FB4C3',
        '#3EB3C3',
        '#3CB1C3',
        '#3BB0C3',
        '#39AEC3',
        '#38ADC3',
        '#36ABC2',
        '#35AAC2',
        '#34A8C2',
        '#32A7C2',
        '#31A5C2',
        '#2FA4C2',
        '#2EA2C1',
        '#2CA1C1',
        '#2B9FC1',
        '#299EC1',
        '#289CC1',
        '#279BC1',
        '#2599C0',
        '#2498C0',
        '#2296C0',
        '#2195C0',
        '#1F93C0',
        '#1E92C0',
        '#1D91C0',
        '#1D8EBF',
        '#1D8CBE',
        '#1D8ABD',
        '#1D88BC',
        '#1E86BB',
        '#1E84BA',
        '#1E82B9',
        '#1E80B8',
        '#1E7EB7',
        '#1F7CB6',
        '#1F7AB5',
        '#1F78B4',
        '#1F76B3',
        '#1F74B2',
        '#2072B1',
        '#2070B0',
        '#206EAF',
        '#206CAE',
        '#206AAD',
        '#2168AC',
        '#2166AB',
        '#2164AA',
        '#2162A9',
        '#2160A8',
        '#225EA8',
        '#225CA7',
        '#225AA6',
        '#2258A5',
        '#2257A4',
        '#2255A4',
        '#2253A3',
        '#2252A2',
        '#2250A1',
        '#234EA0',
        '#234DA0',
        '#234B9F',
        '#23499E',
        '#23489D',
        '#23469C',
        '#23449C',
        '#23439B',
        '#24419A',
        '#243F99',
        '#243E98',
        '#243C98',
        '#243A97',
        '#243996',
        '#243795',
        '#243594',
        '#253494',
        '#233391',
        '#22328F',
        '#21318C',
        '#20308A',
        '#1E2F87',
        '#1D2E85',
        '#1C2D82',
        '#1B2C80',
        '#1A2B7D',
        '#182A7B',
        '#172978',
        '#162876',
        '#152773',
        '#142671',
        '#12256E',
        '#11246C',
        '#102369',
        '#0F2267',
        '#0E2164',
        '#0C2062',
        '#0B1F5F',
        '#0A1E5D',
        '#091D5A',
        '#081D58'
      ]
    } else if (colormap === 'Magma') {
      return [
        '#FFDB00',
        '#FFDA00',
        '#FFD900',
        '#FFD800',
        '#FFD700',
        '#FFD600',
        '#FFD500',
        '#FFD400',
        '#FFD300',
        '#FFD200',
        '#FFD100',
        '#FFD000',
        '#FFCF00',
        '#FFCE01',
        '#FFCD01',
        '#FFCC01',
        '#FFCB01',
        '#FFCA01',
        '#FFC901',
        '#FFC801',
        '#FFC701',
        '#FFC601',
        '#FFC501',
        '#FFC401',
        '#FFC301',
        '#FFC202',
        '#FFC102',
        '#FFC002',
        '#FFBF02',
        '#FFBE02',
        '#FFBD02',
        '#FFBC02',
        '#FFBB02',
        '#FFBA02',
        '#FFB902',
        '#FFB802',
        '#FFB702',
        '#FFB602',
        '#FFB503',
        '#FFB403',
        '#FFB303',
        '#FFB203',
        '#FFB103',
        '#FFB003',
        '#FFAF03',
        '#FFAE03',
        '#FFAD03',
        '#FFAC03',
        '#FFAB03',
        '#FFAA03',
        '#FFA904',
        '#FEA804',
        '#FEA704',
        '#FDA604',
        '#FDA504',
        '#FDA404',
        '#FCA304',
        '#FCA204',
        '#FCA104',
        '#FBA004',
        '#FB9F04',
        '#FB9E04',
        '#FA9D04',
        '#FA9D04',
        '#FA9C04',
        '#F99B04',
        '#F99A04',
        '#F99904',
        '#F89804',
        '#F89704',
        '#F89604',
        '#F79504',
        '#F79404',
        '#F79304',
        '#F69204',
        '#F69205',
        '#F69105',
        '#F59005',
        '#F58F05',
        '#F58E05',
        '#F48D05',
        '#F48C05',
        '#F48B05',
        '#F38A05',
        '#F38905',
        '#F38805',
        '#F28705',
        '#F28605',
        '#F28605',
        '#F18505',
        '#F18405',
        '#F18305',
        '#F08205',
        '#F08105',
        '#F08005',
        '#EF7F05',
        '#EF7E05',
        '#EF7D05',
        '#EE7C05',
        '#EE7B05',
        '#EE7B06',
        '#EC7906',
        '#EA7707',
        '#E97507',
        '#E77408',
        '#E67209',
        '#E47009',
        '#E36E0A',
        '#E16D0A',
        '#E06B0B',
        '#DE690C',
        '#DD670C',
        '#DB660D',
        '#D9640D',
        '#D8620E',
        '#D6600F',
        '#D55F0F',
        '#D35D10',
        '#D25B10',
        '#D05911',
        '#CF5812',
        '#CD5612',
        '#CC5413',
        '#CA5213',
        '#C95114',
        '#C74F15',
        '#C54D15',
        '#C44C16',
        '#C24A16',
        '#C14817',
        '#BF4618',
        '#BE4518',
        '#BC4319',
        '#BB4119',
        '#B93F1A',
        '#B83E1B',
        '#B63C1B',
        '#B53A1C',
        '#B3381C',
        '#B1371D',
        '#B0351E',
        '#AE331E',
        '#AD311F',
        '#AB301F',
        '#AA2E20',
        '#A82C21',
        '#A72A21',
        '#A52922',
        '#A42722',
        '#A22523',
        '#A12424',
        '#9D2323',
        '#9A2222',
        '#972222',
        '#932121',
        '#902121',
        '#8D2020',
        '#8A2020',
        '#861F1F',
        '#831F1F',
        '#801E1E',
        '#7C1E1E',
        '#791D1D',
        '#761D1D',
        '#731C1C',
        '#6F1C1C',
        '#6C1B1B',
        '#691B1B',
        '#651A1A',
        '#621A1A',
        '#5F1919',
        '#5C1919',
        '#581818',
        '#551818',
        '#521717',
        '#4E1717',
        '#4B1616',
        '#481616',
        '#451515',
        '#411515',
        '#3E1414',
        '#3B1414',
        '#371313',
        '#341313',
        '#311212',
        '#2E1212',
        '#2A1111',
        '#271111',
        '#241010',
        '#201010',
        '#1D0F0F',
        '#1A0F0F',
        '#170E0E',
        '#130E0E',
        '#100D0D',
        '#0D0D0D',
        '#090C0C',
        '#060C0C',
        '#030B0B',
        '#000B0B'
      ]
    } else if (colormap === 'Viridis') {
      return [
        '#440154',
        '#440255',
        '#440457',
        '#450659',
        '#45085A',
        '#450A5C',
        '#460B5E',
        '#460D60',
        '#460F61',
        '#471163',
        '#471365',
        '#481567',
        '#481668',
        '#481869',
        '#48196B',
        '#481B6C',
        '#481C6E',
        '#481E6F',
        '#481F71',
        '#482172',
        '#482274',
        '#482475',
        '#482677',
        '#472777',
        '#472978',
        '#472A79',
        '#462C7A',
        '#462D7B',
        '#462F7C',
        '#46307D',
        '#45327E',
        '#45337F',
        '#453580',
        '#453781',
        '#443881',
        '#443982',
        '#433B82',
        '#433C83',
        '#423E84',
        '#423F84',
        '#414185',
        '#414286',
        '#404486',
        '#404587',
        '#404788',
        '#3F4888',
        '#3E4988',
        '#3E4B89',
        '#3D4C89',
        '#3C4D89',
        '#3C4F8A',
        '#3B508A',
        '#3A518A',
        '#3A538B',
        '#39548B',
        '#39568C',
        '#38578C',
        '#37588C',
        '#37598C',
        '#365A8C',
        '#365B8C',
        '#355D8C',
        '#355E8C',
        '#345F8C',
        '#34608C',
        '#33618C',
        '#33638D',
        '#32648D',
        '#31658D',
        '#31668D',
        '#30678D',
        '#30688D',
        '#2F6A8D',
        '#2F6B8D',
        '#2E6C8D',
        '#2E6D8D',
        '#2D6E8D',
        '#2D708E',
        '#2C718E',
        '#2C728E',
        '#2B738E',
        '#2B748E',
        '#2A758E',
        '#2A778E',
        '#29788E',
        '#29798E',
        '#287A8E',
        '#287B8E',
        '#287D8E',
        '#277E8D',
        '#277F8D',
        '#26808D',
        '#26818D',
        '#25828D',
        '#25848D',
        '#24858D',
        '#24868D',
        '#23878D',
        '#23888D',
        '#238A8D',
        '#228B8C',
        '#228C8C',
        '#218D8C',
        '#218E8C',
        '#21908C',
        '#20918B',
        '#20928B',
        '#1F938B',
        '#1F948B',
        '#1F968B',
        '#1F978A',
        '#1F988A',
        '#1F9989',
        '#1F9B89',
        '#1F9C89',
        '#1F9D88',
        '#1F9F88',
        '#1FA087',
        '#1FA187',
        '#20A387',
        '#20A486',
        '#21A585',
        '#22A684',
        '#23A783',
        '#24A983',
        '#25AA82',
        '#26AB81',
        '#27AC80',
        '#28AD7F',
        '#29AF7F',
        '#2AB07E',
        '#2CB17D',
        '#2EB27C',
        '#30B37B',
        '#32B57A',
        '#34B679',
        '#36B778',
        '#38B877',
        '#3AB976',
        '#3CBB75',
        '#3EBC73',
        '#41BD72',
        '#43BE70',
        '#46BF6F',
        '#48C06E',
        '#4BC16C',
        '#4DC26B',
        '#50C369',
        '#52C468',
        '#55C667',
        '#58C765',
        '#5BC863',
        '#5EC961',
        '#61CA5F',
        '#64CB5E',
        '#67CC5C',
        '#6ACD5A',
        '#6DCE58',
        '#70CF56',
        '#73D055',
        '#76D052',
        '#79D150',
        '#7DD24E',
        '#80D34C',
        '#84D44A',
        '#87D448',
        '#8AD546',
        '#8ED644',
        '#91D742',
        '#95D840',
        '#98D83D',
        '#9CD93B',
        '#9FD939',
        '#A3DA36',
        '#A6DB34',
        '#AADB32',
        '#ADDC2F',
        '#B1DC2D',
        '#B4DD2B',
        '#B8DE29',
        '#BBDE27',
        '#BFDF25',
        '#C2DF24',
        '#C6E022',
        '#CAE021',
        '#CDE11F',
        '#D1E11D',
        '#D4E21C',
        '#D8E21A',
        '#DCE319',
        '#DFE31A',
        '#E2E31B',
        '#E5E41C',
        '#E9E41D',
        '#ECE51F',
        '#EFE520',
        '#F3E521',
        '#F6E622',
        '#F9E623',
        '#FDE725'
      ]
    } else if (colormap === 'Jet') {
      return [
        '#050582',
        '#050590',
        '#05059E',
        '#0505AC',
        '#0505BA',
        '#0505C8',
        '#0505D6',
        '#0505E4',
        '#0513E4',
        '#0521E4',
        '#052FE4',
        '#053DE4',
        '#054BE4',
        '#0559E4',
        '#0567E4',
        '#0575E4',
        '#0582E4',
        '#0590E4',
        '#059EE4',
        '#05ACE4',
        '#05BAE4',
        '#05C8E4',
        '#05D6E4',
        '#05E4E4',
        '#13E4D6',
        '#21E4C8',
        '#2FE4BA',
        '#3DE4AC',
        '#4BE49E',
        '#59E490',
        '#67E482',
        '#75E475',
        '#82E467',
        '#90E459',
        '#9EE44B',
        '#ACE43D',
        '#BAE42F',
        '#C8E421',
        '#D6E413',
        '#E4E405',
        '#E4D605',
        '#E4C805',
        '#E4BA05',
        '#E4AC05',
        '#E49E05',
        '#E49005',
        '#E48205',
        '#E47505',
        '#E46705',
        '#E45905',
        '#E44B05',
        '#E43D05',
        '#E42F05',
        '#E42105',
        '#E41305',
        '#E40505',
        '#D60505',
        '#C80505',
        '#BA0505',
        '#AC0505',
        '#9E0505',
        '#900505',
        '#820505',
        '#750505',
        '#690909'
      ]
    }
  }
}
